import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FindADealer from '../../3_Organisms/FindADealer/FindADealer'
import carPic from '../../../assets/images/jellyDefault.png';
import Image from '../../1_Atoms/Image/Image';
import { languageController } from '../../../controllers/language/languageController';
import { stripHTML } from '../../../utils/helpers';

function FindDealerStep({
  handleNextStep,
  vehicleData,
  isTopSectionHidden,
  isEmbeddedOnBnP,
  title,
  subTitle,
  onlyEVDealers,
}) {

  // Only render FindADealer when a different vahicle is selected in step 0.
  const MemoFindADealer = useMemo(() => {
    // TRUE if the selected vehicle is an EV vehicle OR onlyEVDealers is true.
    const isEvOnly = (onlyEVDealers ? onlyEVDealers : (
      vehicleData && vehicleData.isEV ? vehicleData.isEV : false
    ));

    return (
      <FindADealer
        isStepRenderType={true}
        onSelectDealer={(data) => handleNextStep({ dealerData: data })}
        isEVonly={isEvOnly}
        isEmbeddedOnBnP={isEmbeddedOnBnP}
      />
    );
  }, [vehicleData]);

  return (
    <div className="mz-find-dealer-step">
      {
        !isTopSectionHidden && (
          <div className="mz-find-dealer-step__top">
            <div className="mz-container">
              <div className="mz-full-width">
                <h4 className="mz-find-dealer-step__title">{title}</h4>
                {
                  vehicleData && (
                    <div className="mz-find-dealer-step__vehicle">
                      <Image src={carPic} alt={vehicleData.title} isLazy={false} />
                      <div className="mz-find-dealer-step__vehicle-bottom">
                        <h5>{vehicleData.title}</h5>
                        <p className="m-0">
                          {vehicleData.description ? stripHTML(vehicleData.description) : ''}
                          {vehicleData.msrp ? ` - ${languageController.getCopy('global', 'from')} $${vehicleData.msrp}` : ''}</p>
                      </div>
                    </div>
                  )
                }
                <h5 className="mz-find-dealer-step__sub-title">{subTitle}</h5>
              </div>
            </div>
          </div>
        )
      }
      {MemoFindADealer}
    </div >
  )
}

FindDealerStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  vehicleData: PropTypes.object,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  isTopSectionHidden: PropTypes.bool,
  isEmbeddedOnBnP: PropTypes.bool,
  onlyEVDealers: PropTypes.bool,
}

FindDealerStep.defaultProps = {
  title: '',
  subTitle: '',
  isTopSectionHidden: false,
  isEmbeddedOnBnP: false,
  onlyEVDealers: false,
}

export default FindDealerStep